import { use, useCallback, useMemo } from "react";

import type { AlmaCustomPurpose } from "@almamedia/consent/v3";

import { ConsentContext } from "@/src/providers/ConsentProvider";

const useConsent = () => {
  const { purposes, isLoading } = use(ConsentContext);

  const purposeSet = useMemo(() => new Set(purposes), [purposes]);

  const hasConsent = useCallback(
    (purpose: AlmaCustomPurpose): boolean => purposeSet.has(purpose),
    [purposeSet]
  );

  const hasAllConsents = useCallback(
    (required: AlmaCustomPurpose[]): boolean =>
      required.every((p) => purposeSet.has(p)),
    [purposeSet]
  );

  return { purposes, isLoading, hasConsent, hasAllConsents };
};

export default useConsent;
